export default "__VITE_ASSET__3b8e30af__"